import React, { useEffect, useState } from 'react'
import { motion } from "framer-motion";
import { useLocation } from 'react-router-dom';
import UseScrollReveal from '../../Common/UseScrollReveal';
import ModalLayout from '../../Common/ModalLayout';
import BookAppointmentModal from './BookAppointmentModal';
import { getImages } from '../../Common/const';

const ServiceAstonMartinRepair = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const handleMouseMove = (e) => {
        const { clientX, clientY, currentTarget } = e;
        const { left, top, width, height } = currentTarget.getBoundingClientRect();
        const x = ((clientX - left) / width - 2) * 20;
        const y = ((clientY - top) / height - 1) * 20;
        const bgX = ((clientX - left) / width - 5) * 30;
        const bgY = ((clientY - top) / height - 0.5) * 30;
        setPosition({ x, y, bgX, bgY });
    };
    UseScrollReveal()
    // 
    const [openBookAppointment, setOpenBookAppointment] = useState(false);
    const handleBookAppointment = () => {
        setOpenBookAppointment(true);
        document.body.classList.add('body-overflow');
    }
    const closeBookAppointment = () => {
        setOpenBookAppointment(false)
        document.body.classList.remove('body-overflow');
    }
    // Open Direct Modal
    const location = useLocation();
    useEffect(() => {
        if (location.state?.openModal) {
            setOpenBookAppointment(true);
        }
    }, [location.state]);
    return (
        <>
            <section className="common-banner-wrap">
                <img src={getImages('aston_hero.webp')} alt='hero' />
                <div className="container">
                    <div className='common-banner-pos pt-140 text-center'>
                        <h1 className='banner-lg-title text-uppercase wow reveal fadeInUp'>ASTON MARTIN SERVICE</h1>
                        <h2 className='md-title mt-3 avenir-next font-2em fw-500 wow reveal fadeInUp'>in the Tampa Bay Area</h2>
                        <div className='my-4 wow reveal fadeInUp'>
                            <button type='button' className='orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase'
                                onClick={handleBookAppointment}
                            >Schedule Service</button>
                        </div>
                    </div>
                </div>
            </section>
            <section className='exotic-car-wrap'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-lg-6 wow reveal fadeInLeft'>
                            <div className='md-title fw-700 text-uppercase mb-md-4 mb-3 font-2-5em'>ASTON MARTIN SERVICE IN TAMPA, FL</div>
                            <div className='common-text'>
                                <p>At European Exotic Center, we how important it is to keep a vehicle running at peak performance. We provide a high level of one on one access and transparency throughout your Aston Martin service. From early DB5’s, to the latest Vantage and DBS models, we have the tools and expertise to bring your Aston Martin into top mechanical condition. We want to be your go-to shop for all your Porsche service and modification needs.</p>
                            </div>
                            <div className='my-4 wow reveal fadeInUp'>
                                <button type='button' className='orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase'
                                    onClick={handleBookAppointment}
                                >Schedule Service</button>
                            </div>
                        </div>
                        <div className='col-lg-6 text-lg-end text-center mt-lg-0 mt-5 wow reveal fadeInRight'>
                            <img src={getImages('aston-image.png')} alt='service' />
                        </div>
                    </div>
                </div>
            </section>
            <section className='offer-exotic-wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6 pe-lg-5 pt-2 wow reveal fadeInLeft'>
                            <div className='sm-title text-uppercase font-1-9em mb-md-5 mb-3'>Auto Services & Auto <br />Repair We Offer</div>
                            <div className='common-text'>
                                <p>We aren't your standard repair shop; our service center goes above and beyond to handle your cherished vehicle with the utmost care.</p>

                                <p>Our service department offers the following Aston Martin services:</p>
                            </div>
                        </div>
                        <div className='col-lg-6 wow mt-lg-0 mt-5 reveal fadeInRight'>
                            <ul className='oe-list-flex'>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Oil Change/Annual Services</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Leather dash and headliner repairs</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Clutch replacements <br /><span className='font-12'>(Vantage, Manual models)</span></div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Navi display & Cluster display repairs <br /><span className='font-12'>(VH Platform)</span></div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Brake and tire repair</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>And many more services!</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <section className='offer-exotic-wrap skilled-exotic-wrap pt-3'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12 wow reveal fadeInLeft pb-md-5 pb-4'>
                            <div className='md-title font-1-9em eurostile fw-400 text-uppercase mb-md-4 mb-3'>Why Choose Us for Aston Martin Repairs?</div>
                            <div className='common-text'>
                                <p>We know how much our customers appreciate their motorcars, because we feel the same way about these luxury vehicles. That is why we never hire less than the best for our team, because you and your vehicle deserve top-notch treatment.<br />
                                    Our family-owned dealership has over ten years in the business serving those in and around the Tampa Bay area. We are also one of the few factory-authorized Koenigsegg service centers in the United States.<br />
                                    Not only do we provide expert care for your vehicle, we're very competitively priced. Our Aston Martin services are sometimes half the cost of nearby dealerships, while providing a far more personalized customer experience.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='book-appointment-wrap'>
                <div className="mouse-container amr-appointment-container"
                    onMouseMove={handleMouseMove}>
                    <motion.div
                        className="mouse-background"
                        style={{
                            background: `url(${getImages('book-appointment-bg.webp')}) no-repeat center/cover`
                        }}
                        animate={{
                            x: position.bgX,
                            y: position.bgY,
                        }}
                        transition={{ type: "tween", stiffness: 50 }}
                    />
                    <div className='w-100 text-center mouse-text'>
                        <div className='container'>
                            <div className='banner-lg-title font-3-5em text-uppercase wow reveal fadeInUp'>schedule an appointment</div>
                            <div className='sm-title font-1-2em mt-3 wow reveal fadeInUp'>We would love to work with you and have the opportunity to service your unique vehicle.</div>
                            <div className="my-4 wow reveal fadeInUp">
                                <button type="button" className="orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase" onClick={handleBookAppointment}>Schedule Service</button>
                            </div>
                            <div className='text-center wow reveal fadeInUp'>
                                <a href='tel:8135880905' className='sm-title font-1-5em fw-400 avenir-next text-white'>
                                    Or Call (813) 588-0905
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='exotic-vehicle-wrap'>
                <div className='container'>
                    <div className='lg-title font-2-5em fw-400 text-uppercase mb-4 wow reveal fadeInUp'>Schedule Service in Tampa, FL</div>
                    <div className='common-text wow reveal fadeInUp'>
                        <p>It’s easy to schedule a service appointment at European Exotic Center. We know our customers lead busy lives, which is why we make it a priority to make the service experience as convenient as possible. Ferrari owners can make an appointment to take their Ferrari in for service, just give us a call at (813) 592-7722</p>
                    </div>
                </div>
            </section>
            {openBookAppointment &&
                <ModalLayout open={openBookAppointment} close={closeBookAppointment} darkThemeCls='true' modalWidth={1030}>
                    <BookAppointmentModal close={closeBookAppointment} />
                </ModalLayout>
            }
        </>
    )
}

export default ServiceAstonMartinRepair